import React, { useState, createContext } from 'react';

export const CredentialContext = createContext();

const CredentialProvider = props => {
  const [ credentialState, setCredentialState ] = useState(null);

  return (
    <CredentialContext.Provider 
      value={{
        credentialState,
        updateCredentials: data => setCredentialState(data)}}>
      { props.children }
    </CredentialContext.Provider>
  );
};

export default CredentialProvider;